export class HotjarController
{
    private _isInitialized:boolean = false;

    public init():void
    {
        if( this.isInitialized() )
            return;

        // below is a code snipped copied from hotjar. It's not modified aside from formatting and typing.
        (function(h, o, t, j, a, r)
        {
            h.hj = h.hj || function()
            {
                (h.hj.q = h.hj.q || []).push(arguments);
            };
            h._hjSettings = {hjid: 1766713, hjsv: 6};
            a = o.getElementsByTagName('head')[0];
            r = o.createElement('script');
            r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })((window as any), document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');

        this._isInitialized = true;
    }

    public isInitialized():boolean
    {
        return this._isInitialized;
    }
}
